import { useCallback } from 'react'
import { useLogInsCallMutation } from '@/core/services/ins-audit-log'
import { InsAuditReturnedIdentity, InsOperation, InsReturnStatus } from '@/core/models/ins-audit.model'

type LogInsCallParams = {
  patient?: string
  patientFullName?: string
  operation: InsOperation
  resultCode?: number
  returnedIdentity?: InsAuditReturnedIdentity
  returnStatus?: InsReturnStatus
  emitter?: string
  receivedIdentity?: InsAuditReturnedIdentity
}

export function useLogInsCall() {
  const [logInsCall] = useLogInsCallMutation()

  return useCallback(
    async ({ patient, patientFullName, operation, resultCode, returnedIdentity, returnStatus, emitter, receivedIdentity }: LogInsCallParams) => {
      try {
        await logInsCall({
          patient,
          patientFullName,
          operation,
          resultCode,
          returnedIdentity,
          returnStatus,
          emitter,
          receivedIdentity,
        }).unwrap()
        return true
      } catch (error) {
        console.error('[useLogInsCall] Failed to log INS call:', error)
        return false
      }
    },
    [logInsCall]
  )
}
